export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4787.1a33b22b.jpg";